var $schema = "https://schemas.wp.org/trunk/block.json";
var version = "1.0";
var name = "constellation/amortization-calculator";
var title = "Amortization Calculator";
var description = "Amortization calculator";
var icon = "businessperson";
var keywords = ["Amortization", "Calculator"];
var supports = {
  customClassName: false,
  html: false
};
var category = "more";
var attributes = {
  amount: {
    type: "number",
    "default": 200000,
    label: "Loan amount",
    control: "number"
  },
  term: {
    type: "number",
    "default": 360,
    label: "Loan program",
    control: "select",
    choices: [{
      label: "30 year fixed",
      value: 360
    }, {
      label: "15 year fixed",
      value: 180
    }, {
      label: "5-year ARM",
      value: 360
    }]
  },
  rate: {
    type: "number",
    label: "Interest rate",
    "default": 4.176,
    control: "number"
  },
  startMonth: {
    type: "string",
    "default": "Aug",
    label: "Loan start date",
    control: "select",
    choices: [{
      label: "Jan",
      value: "Jan"
    }, {
      label: "Feb",
      value: "Feb"
    }, {
      label: "Mar",
      value: "Mar"
    }, {
      label: "Apr",
      value: "Apr"
    }, {
      label: "May",
      value: "May"
    }, {
      label: "Jun",
      value: "Jun"
    }, {
      label: "Jul",
      value: "Jul"
    }, {
      label: "Aug",
      value: "Aug"
    }, {
      label: "Sep",
      value: "Sep"
    }, {
      label: "Oct",
      value: "Oct"
    }, {
      label: "Nov",
      value: "Nov"
    }, {
      label: "Dec",
      value: "Dec"
    }]
  },
  startYear: {
    type: "number",
    "default": 2024,
    label: "Loan start date",
    control: "select",
    choices: [{
      label: "Loan start date low",
      value: 1900
    }, {
      label: "Loan start date high",
      value: 2100
    }]
  }
};
var amortjsonblock = {
  $schema: $schema,
  version: version,
  name: name,
  title: title,
  description: description,
  icon: icon,
  keywords: keywords,
  supports: supports,
  category: category,
  attributes: attributes
};

export { $schema, attributes, category, amortjsonblock as default, description, icon, keywords, name, supports, title, version };
